import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { WarrantyStatus } from '@generated/sammathnaur.graphql'
import { TranslateModule } from '@ngx-translate/core'

@Component({
    selector: 'app-warranty-status-label',
    templateUrl: './warranty-status-label.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CommonModule,
        TranslateModule
    ]
})
export class WarrantyStatusLabelComponent {
  @Input({ required: true })
  public status!: WarrantyStatus

  @Input()
  public extendedTranslate: boolean = false

  @Input()
  public isHovering: boolean = false

  public WarrantyStatus = WarrantyStatus
}
